import React, { createContext, useContext, useEffect, useState, useMemo } from "react";
import { LANGUAGES, langDir, t as translate } from "@/lib/i18n";

const LanguageContext = createContext(null);

export function LanguageProvider({ children, initialLang = "en" }) {
  const [lang, setLang] = useState(() => localStorage.getItem("hv_lang") || initialLang);

  useEffect(() => {
    localStorage.setItem("hv_lang", lang);
    const dir = langDir(lang);
    document.documentElement.setAttribute("dir", dir);
    document.documentElement.setAttribute("lang", lang);
  }, [lang]);

  const value = useMemo(() => ({
    lang, setLang, languages: LANGUAGES,
    t: (key) => translate(lang, key),
    dir: langDir(lang),
    getLoc: (obj, fallbackKey = "en") => {
      if (!obj) return "";
      if (typeof obj === "string") return obj;
      return obj[lang] || obj[fallbackKey] || Object.values(obj)[0] || "";
    },
  }), [lang]);
  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export const useLang = () => useContext(LanguageContext);
